import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";

import arrowIconWhite from "../../../assets/images/Vector_btn.png";

import ImgDiv from "../../../assets/images/sezione-05-popup-03-03-img-01.svg";

export default function AnalisiApprofondimento({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Comunità interessate", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[2000] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Perimetro di consolidamento"
    >
      <div
        className="
          relative w-full md:w-[1280px] bg-white shadow-2xl
          max-h-[90vh] overflow-y-auto overscroll-contain
        "
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
      >
        {/* Azioni in alto */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("AnalisiApprofondimento")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Contenuto */}
        <div className="px-5 md:px-8 pb-6 -mt-6">

            <h2 className="text-[#3D8E2F] text-[30px] md:text-[40px] font-normal">
                Comunità Interessate
            </h2>

            <p className="text-[#0E3761] text-[16px] md:text-[24px] mt-2 leading-[1.1em] font-bold">
              La natura mutualistica di Reale Group è un elemento distintivo che permea le attività e le relazioni anche sul territorio.
            </p>
              
            <p className="text-[#0E3761] text-[16px] md:text-[24px] mt-2 leading-[1.1em]">
              Questo approccio si traduce in un <b>costante ascolto e coinvolgimento delle comunità</b> nelle quali il Gruppo è presente e opera al fine di promuovere uno sviluppo sostenibile.
            </p>
              
            <p className="text-[#0E3761] text-[16px] md:text-[24px] mt-2 leading-[1.1em]">
              Dal 2017, <b>Reale Foundation</b>, la Fondazione Corporate di Reale Group, è attiva in Italia, Spagna, Cile e Grecia e attraverso le proprie iniziative persegue scopi di interesse generale in ambito culturale, sportivo, di difesa dell’ambiente, civico, di assistenza e di inclusione sociale. Reale Foundation si impegna nel <b>perseguimento degli obiettivi di sviluppo sostenibile definiti dall’Agenda 2030 dell’ONU</b>, attua programmi volti a contrastare l’insorgenza delle malattie croniche favorendo la prevenzione dei fattori di rischio (SDG n. 3), e promuove l’inclusione e lo sviluppo socioeconomico di giovani in condizioni di vulnerabilità (SDGs n. 1 e 8).
            </p>
              
            

            <div className="flex flex-col md:flex-row gap-8 mt-8">
                
                <div className="flex w-full md:w-1/3">
                    <img src={ImgDiv} className="w-full" alt=""></img>
                </div>

                <div className="flex w-full md:w-2/3">
                    <p className="text-[#0E3761] text-[16px] md:text-[24px] mt-2 leading-[1.1em]">
                      Inoltre, interviene con crescente frequenza per <b>sostenere le comunità colpite da calamità naturali</b>, attivando il proprio <b>“Protocollo di emergenza”</b> e pianificando iniziative volte ad aumentare la capacità di prevenire e fronteggiare le conseguenze del cambiamento climatico. Le alleanze strategiche con Enti Locali, Strutture Sanitarie ed Emergenziali permettono a Reale Foundation e a Reale Group di contribuire al <b>Goal 17 “Partnership per gli obiettivi”</b> per l’Agenda 2030 dell’ONU.
                    </p>
                </div>
            </div>
            
            <a href="https://realefoundation.org/" target="_blank" rel="noopener">
              <button
                className="bt-secondary text-[16px] md:text-[22px] mt-12 border-[1px] border-[#0E3761]"
              >
                <img
                  src={arrowIconWhite}
                  alt="Arrow"
                  className="inline-block mr-2 w-[20px] h-[20px]"
                />
                Visita realefoundation.org
              </button>
            </a>

        </div>

        </div>
    </div>,
    document.body
  );
}
